import { useCallback, useMemo } from 'react';
import { v4 as uuidv4 } from 'uuid';

import { BROWSER, COOKIE_KEY_NAME } from '@/constants';
import { SCREEN_HINT_SIGNUP, authorize } from '@/features/api';
import { getAdParamsForAuth0 } from '@/utils/ad';
import { setupCookie } from '@/utils/cookie';

/**
 * プロパティ
 */
export type Props = {
  // stateに指定するリダイレクト先の画面パス
  redirectPath?: string;
  // シリアルコード
  code?: string;
};

/**
 * stateが複数あった場合の接続用文字列
 */
const STATE_CONNECT_STR = '#' as string;

/**
 * ポケトーク認証ログイン(Auth) カスタムフック
 *
 * @param param0
 */
export const useLoginAuth = ({ redirectPath, code }: Props) => {
  /**
   * PTID認証API URL
   */
  const ptidApiUrl = useMemo(
    () => `${BROWSER.DOMAIN.API}${BROWSER.API_URL.PTID}`,
    [],
  );

  /**
   * stateに指定する値を作成
   */
  const createState = useCallback((uuid: string, path?: string) => {
    let value = uuid;
    if (path) {
      // プロパティにリダイレクト先の画面パスが指定されている場合は「#」でつなぐ
      const pathUrl = `${process.env.REACT_APP_API_DOMAIN}${path}`;
      value = `${value}${STATE_CONNECT_STR}${pathUrl}`;
    }

    return value;
  }, []);

  /**
   * ログイン認証(Auth0)
   *
   * @param isSignUp サインアップ画面を表示するかどうか
   */
  const loginAuth = useCallback(
    (isSignUp?: boolean) => {
      // UUIDを生成
      const uuid = uuidv4();
      // CookieにUUIDを保存
      setupCookie(COOKIE_KEY_NAME.PTBR_STATE, uuid);
      // state
      const state = createState(uuid, redirectPath);

      // 広告パラメータを取得
      const adParams = getAdParamsForAuth0();

      // ログイン認証実行
      if (isSignUp) {
        // サインアップ
        authorize(
          {
            redirectUri: ptidApiUrl,
            state,
            screenHint: SCREEN_HINT_SIGNUP,
            code,
            adParams,
          },
          false,
        );
      } else {
        authorize(
          {
            redirectUri: ptidApiUrl,
            state,
            adParams,
          },
          false,
        );
      }
    },
    [code, createState, ptidApiUrl, redirectPath],
  );

  return {
    loginAuth,
  };
};
